<template>
  <div class="deny" :style="{ width }" @click="emitEvent($event)">
    {{ text }}
  </div>
</template>
<script>
export default {
  name: "DenyButton",
  props: {
    text: {
      type: String,
      default: "Deny"
    },
    width: {
      type: String,
      default: "210px"
    }
  },
  methods: {
    emitEvent(event) {
      event.stopPropagation();
      this.$emit("onDeny");
    }
  }
};
</script>
<style>
.deny {
  align-items: center;
  background: var(--component_modals_common_denyButton_deny_background);
  border: var(--component_modals_common_denyButton_deny_border);
  border-radius: var(--component_modals_common_denyButton_deny_border-radius);
  color: var(--component_modals_common_denyButton_deny_color);
  display: flex;
  font-family: var(--component_modals_common_denyButton_deny_font-family);
  font-size: var(--component_modals_common_denyButton_deny_font-size);
  height: 65px;
  justify-content: center;
  letter-spacing: 1.84px;
  padding: var(--component_modals_common_denyButton_deny_padding);
}
</style>
